import { useEffect } from 'react';

import { useActions, useAppState } from '@/overmind';

export function useNavigateOnCalculationResult() {
  const appState = useAppState();
  const isCalculationTacticResultUnavailable =
    appState.calculation.isCalculationTacticResultUnavailable;
  const { showCalculationTacticResult } = useActions();

  useEffect(() => {
    if (isCalculationTacticResultUnavailable) return;

    showCalculationTacticResult();
  }, [isCalculationTacticResultUnavailable, showCalculationTacticResult]);
}
